import { render, staticRenderFns } from "./osd.vue?vue&type=template&id=71d42b96&scoped=true"
import script from "./osd.vue?vue&type=script&lang=js"
export * from "./osd.vue?vue&type=script&lang=js"
import style0 from "./osd.vue?vue&type=style&index=0&id=71d42b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d42b96",
  null
  
)

export default component.exports